const $main = document.querySelector("#MainContent");
console.log("Main", $main);

const getContainer = () => {
  const $textarea = $main.querySelector("form-embed")?.shadowRoot;
  return $textarea;
};
const setter = ($container) => {
  // Variables from URL
  const url = new URLSearchParams(location.search);
  const name = url.get("name");
  const email = url.get("email");
  const sku = url.get("sku");

  // Elements
  const $name = $container.querySelector("#first_name");
  const $email = $container.querySelector("#email");
  const $nameLabel = $container.querySelector("#first_name + label");
  const $emailLabel = $container.querySelector("#email + label");
  const $textarea = $container.querySelector("textarea");
  const $textareaLabel = $container.querySelector("textarea + label");

  setTimeout(() => {
    $name.value = name;
    $nameLabel.style.transform = "var(--input-label-transform)";
    $email.value = email;
    $emailLabel.style.transform = "var(--input-label-transform)";
    $name.dispatchEvent(new CustomEvent("change", { bubbles: true }));
    $name.dispatchEvent(new CustomEvent("input", { bubbles: true }));
    $email.dispatchEvent(new CustomEvent("change", { bubbles: true }));
    $email.dispatchEvent(new CustomEvent("input", { bubbles: true }));
  }, 100);

  $textarea.value = `SKU: ${sku}`;
  $textarea.dispatchEvent(new Event("change", { bubbles: true }));
  $textarea.focus();
  $textareaLabel.style.transform = "var(--input-label-transform)";
};

const observer = new MutationObserver(() => {
  const $container = getContainer();
  if (!$container) return;

  observer.disconnect();
  setter($container);
});

if ($main) {
  const $container = getContainer();
  if ($container) setter($container);

  observer.observe($main, {
    childList: true,
    subtree: true,
  });
}
